import { apicall } from "../../services/api";
import { OPTIONS_DELETE, OPTIONS_CLEAR_ALL, OPTIONS_DATA, OPTIONS_ERROR, OPTIONS_LOADING } from "./actionTypes";

export const uploadOptionImg = (optionData, name) => async (dispatch) => {
    try {
		dispatch({
			type: OPTIONS_LOADING,
			payload: {name},
		});
		const res = await apicall("/polls/single/upload", "post", optionData, {
			headers: {
				"Content-Type": "multipart/form-data",
				"Access-Control-Allow-Origin": "*",
				authorization: localStorage.getItem("authorization"),
			},
		});
		const data = await res?.data
		if(res.data.success){
			dispatch({
				type: OPTIONS_DATA,
				payload: res.data.data,
			});
		}else{
			dispatch({
				type: OPTIONS_ERROR,
				payload: { name, msg: res.data.message },
			});
		}
	} catch (err) {
		dispatch({
			type: OPTIONS_ERROR,
			payload: { name, msg: err.response.data.message },
		});
	}
};

export const deleteOptionImg = (body) => async(dispatch) => {
	try {
		const res = await apicall("/polls/single/delete", "delete", body);
        if(res.data.success){
			dispatch({
				type: OPTIONS_DELETE,
				payload: res.data.data,
			});
		}else{
			dispatch({
				type: OPTIONS_ERROR,
				payload: { name:body?.name, msg: res.data.message },
			});
		}
	} catch (error) {
		dispatch({
			type: OPTIONS_ERROR,
			payload: { name:body?.name, msg: error.response.data.message },
		});
	}
}

export const clearPollOptions = ()=> async (dispatch) =>{
	try {
		dispatch({
			type: OPTIONS_CLEAR_ALL,
		})
	} catch (error) {
		
	}
}

// todo: delete all images link if not saved
export const deleteAllOptionImgs = (body) => async(dispatch) => {
	try {
		dispatch(clearPollOptions());
		const res = await apicall("/polls/single/allDelete", "delete", body);
	} catch (error) {
		console.log("Delete all imgs:error:", error.response.data.message)
	}
}